import { ActivitySubscriptions, ActivitySubscriptionUpdateData } from '@recruitee/http/types';
import { createSingleEntityStore, pipeState } from '@recruitee/ngrx';

import { EntityStoreKey } from '../../types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<ActivitySubscriptions | null>()(EntityStoreKey.activitySubscriptions, {
    customActions: adapter => ({
      update: (state, payload: ActivitySubscriptionUpdateData) => adapter.markAsPending(state),
      resetToDefaults: state => adapter.markAsPending(state),
      resetToDefaultsSuccess: (state, payload: ActivitySubscriptions) =>
        pipeState(adapter.save(state, payload), next => adapter.markAsLoaded(next)),
    }),
  });

export {
  actions as ActivitySubscriptionsActions,
  selectors as ActivitySubscriptionsSelectors,
  reducer as ActivitySubscriptionsReducer,
  namespace as ActivitySubscriptionsNamespace,
};
